import { defineStyleConfig as e } from "@chakra-ui/react";
import { isTouchScreenDevice as n } from "../../theme-helper.js";
import { ThemeColorToken as o, ThemeFontToken as r } from "../theme-tokens.js";
const t = {
  color: o.OnBackground,
  fontFamily: r.Body,
  fontWeight: "normal",
  textDecorationLine: "underline",
  textUnderlineOffset: "3px",
  border: 0,
  _hover: {
    color: n() ? o.OnBackground : o.AccentHover
  },
  _active: {
    color: o.AccentActive
  }
}, f = e({
  baseStyle: t
});
export {
  f as linkConfig
};
